import downloadImage from '@images/golang-development/lets-talk.png';

export const letsTalkData = {
  firstHeading: 'Not sure if Rust is the right choice for your project?',
  id: 'rust-lets-talk',
  secondHeading: 'Contact our Rust experts.',
  buttonLink: '/services/rust-development/#contact',
  downloadImage: downloadImage,
};
